(function() {
	// globals
	window.EWO.Election = window.EWO.Election || {};


	// module functions
	EWO.Election.renderStatisticsLists = function(ctx) {
		var urlQueryString = new URLSearchParams(ctx.querystring);
		var filter = Object.fromEntries(urlQueryString);
		$.extend(filter, ctx.params);

		$.when(
			ejs.preloadTemplate('/app/election/statisticsLists/templates/statisticsLists.ejs'),
			$.get(EWO.config.apiUrlPrefix + '/survey/statisticsLists', filter),
			$.get(EWO.config.apiUrlPrefix + '/constituencies/municipalitiesforconstituencies', filter)
		)
		.done(function(templateUrl, list, municipalities) {
			$('.js-election-container').html(ejs.rr(templateUrl, {
				list: list[0],
				data: municipalities,
				filter: filter
			}));

			$('.sortable').DataTable({'paging': false, 'lengthChange': false, 'info': false });
		});
	};

	//events
	$(document).on('submit', '.js-electionStatisticsLists .js-filterform', function(ev) {
		var el = $(ev.currentTarget);
		ev.preventDefault();
		var filter = el.serialize();
		page(document.location.pathname + (filter ? '?' + filter : ''));
	});

	$(document).on('click', '.js-electionStatisticsLists .js-csv-export', function() {
		var filterForm = $('.js-electionStatisticsLists .js-filterform');
		var expFilter = filterForm.serialize();
		window.location.href = EWO.config.apiUrlPrefix + '/survey/statisticsListsCsvExport?' + expFilter;
	});

	// module startup

	//setup routing
	page('/election/:electionId/constituency/:constituencyId/expListvotes', EWO.Election.renderStatisticsLists);
})();
